import { Outlet } from "react-router";
import { SignedInShell } from "./SignedInShell";

/** The pages that need a login (orders, invoices, account), inside the signed-in chrome. */
export function SignedInLayout() {
  return (
    <SignedInShell>
      <Outlet />
    </SignedInShell>
  );
}
